import { z } from "zod";

export const taskStatusEnum = z.enum(["PENDING", "IN_PROGRESS", "DONE"]);
export const priorityEnum2 = z.enum(["LOW", "MEDIUM", "HIGH", "URGENT"]);

export const createStaffSchema = z.object({
  firstName: z.string().min(1),
  lastName: z.string().min(1),
  position: z.string().min(1),
  startDate: z.coerce.date(),
  email: z.string().email().optional().nullable(),
  phone: z.string().optional().nullable(),
  // Duties and other details of the job.
  description: z.string().max(5000).optional().nullable(),
  // Buildings the person covers (Unit.building values), stored uppercase and de-duplicated.
  assignedBuildings: z
    .array(z.string().trim().min(1).max(10).transform((b) => b.toUpperCase()))
    .max(50)
    .transform((list) => [...new Set(list)].sort())
    .optional(),
});
export const updateStaffSchema = createStaffSchema.partial().extend({
  isActive: z.boolean().optional(),
});

export const createTimeEntrySchema = z.object({
  date: z.coerce.date(),
  clockIn: z.coerce.date(),
  clockOut: z.coerce.date().optional().nullable(),
  notes: z.string().optional().nullable(),
});
export const updateTimeEntrySchema = z.object({
  clockOut: z.coerce.date().optional().nullable(),
  notes: z.string().optional().nullable(),
});

export const createTaskSchema = z.object({
  title: z.string().min(1),
  description: z.string().optional().nullable(),
  priority: priorityEnum2.optional().default("MEDIUM"),
  dueDate: z.coerce.date().optional().nullable(),
});
export const updateTaskSchema = z.object({
  title: z.string().optional(),
  description: z.string().optional().nullable(),
  priority: priorityEnum2.optional(),
  dueDate: z.coerce.date().optional().nullable(),
  status: taskStatusEnum.optional(),
});
